





















import { Component, Vue, Prop } from 'vue-property-decorator';

// 声明组件*****************
@Component({
  components: {

  }
})
export default class StateInfo extends Vue {
    // props
    @Prop({ default:()=>({}) }, Object) 
    private data!: object
    //   属性*****************


    // 方法*****************
}
